<!--
  ~ Copyright (C) 2022 to Present Applause App Quality, Inc. All rights reserved.
  -->

<ngf-pill-list>
  <ng-template #templatesOutlet />
</ngf-pill-list>
